<div class="login-container">
  <div class="login-brand">
    <div class="brand-decoration"></div>
    <div class="brand-content">
      <span class="brand-eyebrow">Nyzed</span>
      <h1 class="brand-title">Recupera<br /><em>l'accesso</em></h1>
      <p class="brand-tagline">
        Ti invieremo un link per reimpostare la password.<br />
        Controlla anche la cartella spam.
      </p>
    </div>
  </div>

  <div class="login-form-side">
    <div class="login-card">

      <ng-container *ngIf="!sent; else successState">
        <h2>Password dimenticata</h2>

        <div class="error-msg" *ngIf="error">{{ error }}</div>

        <div class="input-group">
          <input
            class="input-field"
            type="email"
            placeholder="La tua email"
            [(ngModel)]="email"
            (keyup.enter)="submit()"
            autocomplete="email"
            autocapitalize="off"
          />
        </div>

        <button class="submit-button" (click)="submit()" [disabled]="loading">
          {{ loading ? 'Invio in corso...' : 'Invia link di recupero' }}
        </button>
      </ng-container>

      <ng-template #successState>
        <div class="success-box">
          <span class="success-icon">✦</span>
          <h2>Email inviata</h2>
          <p>Se l'indirizzo <strong>{{ email }}</strong> è registrato, riceverai le istruzioni entro pochi minuti.</p>
          <p class="success-hint">Controlla anche la cartella spam.</p>
        </div>
      </ng-template>

      <p class="register-link" style="margin-top:1.5rem">
        <a routerLink="/login">← Torna al login</a>
      </p>
    </div>
  </div>
</div>
